import { IThamSoHeThongUpdateActiveStatus } from "../../../model/request/category/IThamSoHeThongUpdateActiveStatus";
import { IThamSoHeThongViewModel } from "../../../model/response/category/IThamSoHeThongViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThamSoHeThongActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS:{} as IThamSoHeThongViewModel[],
    LOAD_ERROR: "",

    UPDATE_ACTIVE_STATUS_START: {} as IThamSoHeThongUpdateActiveStatus,
    UPDATE_ACTIVE_STATUS_SUCCESS: undefined,
    UPDATE_ACTIVE_STATUS_ERROR: "",

    SELECTED_THAM_SO: "",

    CHANGE_DATA: {} as IThamSoHeThongViewModel,

    UPDATES_START: {} as IThamSoHeThongViewModel[],
    UPDATES_SUCCESS: "",
    UPDATES_ERROR: "",
}

export const eThamSoHeThongActionIds = generateActionTypeIds(eThamSoHeThongActionsObj, "THAM_SO_HE_THONG");
export type IThamSoHeThongActionTypes = IGenericActionType<typeof eThamSoHeThongActionsObj, "THAM_SO_HE_THONG">;